import { c as _c } from "react/compiler-runtime";
import { isAddressEqual } from "@opensea/utils";
import { useSnapshot } from "valtio";
import { useConnect, useConnections } from "../polychain/hooks";
import { AccountActions, AccountState } from "../stores/accountStore";
export const useExternalAccount = () => {
  const $ = _c(8);
  const {
    externalAccount
  } = useSnapshot(AccountState);
  const {
    connect,
    isConnecting
  } = useConnect();
  const connections = useConnections();
  let t0;
  if ($[0] !== connect || $[1] !== connections || $[2] !== externalAccount) {
    t0 = async () => {
      if (!externalAccount) {
        return;
      }
      const connection_0 = connections.find(connection => connection.addresses.some(address => isAddressEqual(address, externalAccount.address)));
      if (!connection_0) {
        return;
      }
      AccountActions.setAccount(externalAccount);
      await connect(connection_0.connector, {
        address: externalAccount.address,
        switchOnConnect: true
      });
      AccountActions.setExternalAccount(undefined);
    };
    $[0] = connect;
    $[1] = connections;
    $[2] = externalAccount;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const connectWithExternalAccount = t0;
  let t1;
  if ($[4] !== connectWithExternalAccount || $[5] !== externalAccount || $[6] !== isConnecting) {
    t1 = {
      account: externalAccount,
      connect: connectWithExternalAccount,
      isConnecting
    };
    $[4] = connectWithExternalAccount;
    $[5] = externalAccount;
    $[6] = isConnecting;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};